import { EntityState } from "v2/store/onboardingEntityApi";

type MandatoryReviewFields = {
  dateOfIncorporation: string;
  states: EntityState[];
};

export const hasIncorporationDate = (details: MandatoryReviewFields): boolean =>
  Boolean(details.dateOfIncorporation);

export const hasHomeState = (details: MandatoryReviewFields): boolean =>
  details.states.some((state) => state.isHome);

export const isEntityReviewComplete = (
  details: MandatoryReviewFields
): boolean => hasIncorporationDate(details) && hasHomeState(details);
